<div class="container mb-5">
  <div class="row">
    <div class="col-sm-2">
      <app-dashmenu></app-dashmenu>
    </div>
    <div class="col-sm-10">
      <div class="card p-2">
        <script>

        </script>
        <!-- <button class="btn btn-primary" (click)="openPDF()" type="button" name="button" style="width:100%;"><i class="fa fa-file-pdf-o"></i> Generate PDF</button> -->

        <div id="facture" class="container mt-5">
          <div class="row mb-5">
            <div class="col-6">
              <h4 class="titreFacture">Facture</h4>
              <h5 class="nomBuyer">{{user.BPRNUM}} </h5>
              <p class="adresse">{{user.BPAADDLIG0}} {{user.CTY}}</p>
            </div>
            <!-- <div class="col-6 mt-3 text-end">
              <p class="p-0 m-0"><strong>Facture Num° :</strong> 1711547</p>
              <p class="p-0 m-0"><strong>Date Facture :</strong> 17/06/2022</p>
              <p class="p-0 m-0"><strong>Commande Num° :</strong> 2254589</p>
            </div> -->
            </div>
          <div class="row mb-5">
            <div class="table-responsive mt-5">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">Produit</th>
                    <th scope="col">Quantité</th>
                    <th scope="col">Prix unitaire HT</th>
                    <th scope="col">Montant HT</th>
                    <th scope="col">Montant TTC</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of factureItems" >
                    <td>{{item.ITMDES}}</td>
                    <td>{{item.QTY}}</td>
                    <td>{{item.NETPRI}} MAD</td>
                    <td>{{item.NETPRI*item.QTY | number : '1.2-2'}} MAD</td>
                    <td>{{(item.NETPRI*item.QTY)+(item.NETPRI*item.QTY)*0.2 | number : '1.2-2'}} MAD</td>
                  </tr>
                  <tr>
                    <td colspan="4"><strong>Montant Total TTC</strong></td>
                    <td><strong>{{total| number : '1.2-2'}} MAD</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- <div class="row mt-5">
          <div class="col-12 text-end">
            <button (click)="openPDF()" type="button" class="generatePDF" name="button"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> Générer la facture en PDF</button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>
